import { isFieldValid } from '../utils/validation';
import { isExperienceEditor } from './experience-editor';
export const getFieldValue = (field, key = undefined) => {
    if (!field)
        return null;
    else if (!!key)
        return field && field.value && field.value[key];
    return field && field.value;
};
export const getSiteName = (sitecoreURL) => {
    const { value: siteLink } = sitecoreURL;
    const { linktype, href } = siteLink;
    if (linktype === 'internal' && href) {
        const siteNameArray = href.split('/');
        return siteNameArray[siteNameArray.length - 1];
    }
    else {
        return '';
    }
};
export const getLinkHref = (sitecoreURL) => {
    const { value: siteLink } = sitecoreURL;
    const { linktype, href } = siteLink;
    if (linktype === 'internal' && href) {
        const siteNameArray = href.split('/');
        sitecoreURL.value.href = siteNameArray[siteNameArray.length - 1];
        return sitecoreURL;
    }
    else {
        return sitecoreURL;
    }
};
export const getParsedValue = (value) => {
    if (!value) {
        return;
    }
    return value.replace(/\[\[/g, '<').replace(/\]\]/g, '>');
};
export const getParsedField = (field) => {
    if (!isFieldValid(field)) {
        return;
    }
    else if (typeof window !== 'undefined' && isExperienceEditor()) {
        return field;
    }
    else {
        const value = field.value;
        const parsedValue = getParsedValue(value);
        return {
            value: parsedValue,
        };
    }
};
export function debounced(delay, fn) {
    let timerId;
    return function (...args) {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
            fn(...args);
            timerId = null;
        }, delay);
    };
}
export const defineRegionFieldFromTitle = (componentTitle) => {
    if (isFieldValid(componentTitle)) {
        return undefined;
    }
    else {
        return 'region';
    }
};
export const defineAriaLabelFromTitle = (componentTitle, ariaLabel) => {
    if (isFieldValid(componentTitle)) {
        return undefined;
    }
    else {
        return ariaLabel && ariaLabel.value;
    }
};
